import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IdParams } from 'types/api'
import { IBidTechnicalFactorItem } from 'types/bids/bidTechnicalFactorItems'

export const bidTechnicalFactorItemsApi = createApi({
  reducerPath: 'bidTechnicalFactorItems',
  baseQuery,
  endpoints: (builder) => ({
    bidTechnicalFactorItems: builder.query<IBidTechnicalFactorItem[], void>({
      query: () => ({
        url: '/bid-technical-factor-items',
      }),
    }),

    bidTechnicalFactorItem: builder.query<IBidTechnicalFactorItem, IdParams>({
      query: ({ id }) => `/bid-technical-factor-items/${id}`,
    }),

    createBidTechnicalFactorItem: builder.mutation<
      IBidTechnicalFactorItem,
      Partial<IBidTechnicalFactorItem>
    >({
      query: (body) => ({
        url: '/bid-technical-factor-items',
        body,
        method: 'post',
      }),
    }),

    updateBidTechnicalFactorItem: builder.mutation<
      IBidTechnicalFactorItem,
      Partial<IBidTechnicalFactorItem>
    >({
      query: (body) => ({
        url: `/bid-technical-factor-items/${body.id}`,
        body,
        method: 'put',
      }),
    }),

    deleteBidTechnicalFactorItem: builder.mutation<void, IdParams>({
      query: ({ id }) => ({
        url: `/bid-technical-factor-items/${id}`,
        method: 'delete',
      }),
    }),
  }),
})

export const {
  useBidTechnicalFactorItemQuery,
  useBidTechnicalFactorItemsQuery,
  useCreateBidTechnicalFactorItemMutation,
  useUpdateBidTechnicalFactorItemMutation,
  useDeleteBidTechnicalFactorItemMutation,
} = bidTechnicalFactorItemsApi
